import { Injectable } from '@angular/core';
import { GTopicService } from '../General/g-topic.service';
import { AppService } from '../App/app.service';
import { LanguageProvider } from './language.provider';

@Injectable()
export class TopicService extends GTopicService {

  constructor(protected languageProvider: LanguageProvider, protected appService: AppService) {
    super(languageProvider, appService);
    this.language = languageProvider.getLanguage();
    this.type = 'sort';
    this.getConfiguration();
    this.getState();
   }

  /** loads the configuration for this topic */
  getConfiguration(): void {
    this.configuration = this.appService.getTopicConfiguration('sort');
  }

  getState(): void {
    this.state = this.appService.getTopicState('sort');
  }
}
